import { useEffect } from 'react';

import { focusDrawerContent } from './utils';

// The menu or confirmation dialog that launched the drawer hands focus back to its own trigger after
// the drawer opens, which leaves Escape outside the drawer; focus moves in once the form is shown.
const useFocusDrawerContent = ({ isReady, contentRef }) => {
  useEffect(() => {
    if (!isReady) {
      return;
    }

    const frameId = window.requestAnimationFrame(() => focusDrawerContent(contentRef.current));

    return () => window.cancelAnimationFrame(frameId);
  }, [contentRef, isReady]);
};

export default useFocusDrawerContent;
